import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IDashboardCard } from "../../../Pages/Dashboard/IDashboard";

export const DashboardCardSlice = createSlice({
  name: "DashboardCard",
  initialState: { isLoading: false, data: {} } as IReduxState<IDashboardCard>,
  reducers: {
    dashboardCard: (state) => {
      state.isLoading = true;
    },
    successDashboardCard: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureDashboardCard: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
  },
});

export const { dashboardCard, failureDashboardCard, successDashboardCard } =
  DashboardCardSlice.actions;

export default DashboardCardSlice.reducer;
